import React from 'react'
import { SupplierManagementAdminStyled } from './styled'
import {
  Button,
  Modal,
  Image,
  InputSearch,
  Paginate,
  Section,
  SelectBox,
  Table,
  Spinner,
  Input,
} from '../../components'
import { ICONS } from '../../themes'
import { ROUTE_PATH, redirect, STRING } from '../../helpers'
import {
  supplierManagementController,
  buyermangeController,
} from '../../apiService'
import axios from 'axios'
import { dateMonDayYearTime } from '../../helpers/functions/format'
import FileDownload from 'js-file-download'
import { isEmpty } from 'lodash'

export class SupplierManagementAdminContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      options: [
        {
          allSuppliers: [
            {
              value: 'All Supplier',
              label: 'All Supplier',
              id: 0,
            },
            {
              value: 'Main Directory',
              label: 'Main Directory',
              id: 1,
            },
            {
              value: 'My Supplier',
              label: 'My Supplier',
              id: 2,
            },
          ],
        },
        {
          allStatus: [
            { value: 'all_status', label: 'All Status', id: 0 },
            { value: 'Approved', label: 'Approved', id: 1 },
            { value: 'wait_active', label: 'Wait for active', id: 4 },
            { value: 'wait_approval', label: 'Wait for approve', id: 3 },
            { value: 'Rejected', label: 'Rejected', id: 2 },
          ],
        },
        {
          allPreAssessment: [
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
          ],
        },
        {
          activeStatus: [
            { value: 'all_status', label: 'All', id: 3 },
            { value: 'active', label: 'Active', id: 1 },
            { value: 'inactive', label: 'Inactive', id: 2 },
          ],
        },
      ],
      isSortBy: [
        { name: 'tax_id', value: undefined },
        { name: 'company_name', value: undefined },
        { name: 'name', value: undefined },
        { name: 'email', value: undefined },
        { name: 'phone', value: undefined },
        { name: 'status', value: undefined },
        { name: 'createDate', value: undefined },
      ],
      isLoading: false,
      isHistoryModalOpen: false,
      activePage: 1,
      searchPage: 1,
      searchKeyWord: '',
      orderBy: 'asc',
      sortFiedName: '',
      taxId: '',
      resSuplierMamagementList: {
        limit: null,
        next_page: null,
        offset: null,
        page: null,
        prev_page: null,
        records: [],
        total_page: null,
        total_record: null,
      },
      data: [],
      selectedApproveStatus: 0,
      selectedSupplierStatus: 0,
      selectedAccountStatus: 3,
    }
  }

  componentDidMount() {
    this.fetchSupplierList()
  }

  setIsLoading = (status = false) => {
    this.setState({ isLoading: status })
  }

  fetchSupplierList = async () => {
    try {
      this.setIsLoading(true)
      const DEFAUL_SELECTED = 0
      const params = {
        supplierType: this.state.selectedSupplierStatus || DEFAUL_SELECTED,
        accountStatus: this.state.selectedAccountStatus || DEFAUL_SELECTED,
        approveStatus: this.state.selectedApproveStatus || DEFAUL_SELECTED,
        keyWord: this.state.searchKeyWord,
        page: this.state.activePage,
        sortName: this.state.sortFiedName,
        sortBy: this.state.orderBy,
        taxId: this.state.taxId,
      }
      const res = await supplierManagementController().getList(params)
      if (res) {
        this.setState({
          data: res.result.records ? res.result.records : [],
          resSuplierMamagementList: res.result,
        })
        this.setIsLoading(false)
      }
    } catch (error) {
      throw error
    }
  }

  findSortBy = evt => {
    let sortBy = ''
    this.state.isSortBy.find(column => {
      if (column.name === evt && column.value == undefined) {
        sortBy = 'asc'
      } else if (column.name === evt && column.value == 'asc') {
        sortBy = 'desc'
      } else if (column.name === evt && column.value == 'desc') {
        sortBy = 'asc'
      }
      return sortBy
    })
    return sortBy
  }

  toggleSort = evt => {
    const orderBy = this.findSortBy(evt)
    const sortFiedName = evt
    this.setState(
      prevState => {
        const isSortBy = prevState.isSortBy.map(column => ({
          ...column,
          value:
            column.name === evt
              ? column.value !== undefined
                ? column.value === 'asc'
                  ? 'desc'
                  : 'asc'
                : 'asc'
              : undefined,
        }))
        return { ...prevState, isSortBy, orderBy, sortFiedName }
      },
      () => {
        this.fetchSupplierList()
      }
    )
  }

  filterSortByValue = evt => {
    return this.state.isSortBy
      .filter(columns => columns.name === evt)
      .map(column => column.value)[0]
  }

  toggleModal = () => {
    this.setState(prevState => ({
      isHistoryModalOpen: !prevState.isHistoryModalOpen,
    }))
  }

  onInputSearchChange = event => {
    this.setState({ searchKeyWord: event.target.value })
  }

  onEnter = event => {
    if (event.key === 'Enter' && event.keyCode === 13) {
      this.setState(
        { activePage: 1, searchKeyWord: this.state.searchKeyWord.trim() },
        () => {
          this.fetchSupplierList()
        }
      )
    }
  }

  onPageChange = pageNumber => {
    this.setState(
      prevState => {
        return { ...prevState, activePage: pageNumber }
      },
      () => {
        this.fetchSupplierList()
      }
    )
  }

  cleardata = () => {
    this.setState({ activePage: 1, searchKeyWord: '' }, () => {
      this.fetchSupplierList()
    })
  }

  onClickExport = () => {
    return supplierManagementController()
      .exportSupplier()
      .then(res => FileDownload(res.data, 'supplier.csv'))
  }

  onClickEdit = supplierData => {
    if (supplierData) {
      this.props.history.push(
        ROUTE_PATH.SUPPLIER_EDIT_FORM_ADMIN.PATH + `:${supplierData.id}`,
        {
          approveStatus: supplierData.approve_status,
        }
      )
    }
  }

  onSelectSupplierType = id => {
    this.setState({ selectedSupplierStatus: id }, () =>
      this.fetchSupplierList()
    )
  }

  onSelectStatusSuppiler = id => {
    this.setState({ selectedApproveStatus: id }, () => this.fetchSupplierList())
  }

  onSelectAccountActive = id => {
    this.setState({ selectedAccountStatus: id }, () => this.fetchSupplierList())
  }

  matchValueSelected = (option = [], selectedId) => {
    return option.find(value => value.id === selectedId)
  }

  renderStatus = statusNumber => {
    switch (statusNumber) {
      case 0:
        return <p className="wait-for-approval-status">Wait for approval</p>
      case 1:
        return <p className="apporved-status">Apporved</p>
      case 2:
        return <p className="rejected-status">Rejected</p>
      case 3:
        return <p className="wait-for-approval-status">Wait for activate</p>

      default:
        break
    }
  }

  renderButton = (supplierData = { ...supplierData, approve_status: 0 }) => {
    switch (supplierData.approve_status) {
      case 0:
        return (
          <Button
            className="link"
            onClick={() => this.onClickEdit(supplierData)}
          >
            <Image
              className="edit-icon"
              src={ICONS['icon-edit.svg']}
              alt="edit"
            />
          </Button>
        )

      case 1:
        return (
          <Button
            className="link"
            onClick={() => this.onClickEdit(supplierData)}
          >
            <Image
              className="edit-icon"
              src={ICONS['icon-edit.svg']}
              alt="edit"
            />
          </Button>
        )
      case 2:
        return (
          <Button
            className="link"
            onClick={() => {
              this.props.history.push(
                ROUTE_PATH.SUPPLIER_DETAIL_FORM_ADMIN_REJECT.PATH +
                  ':' +
                  supplierData.id
              )
            }}
          >
            <Image
              className="detail-icon"
              src={ICONS['icon-detail.svg']}
              alt="detail"
            />
          </Button>
        )
      case 3:
        return (
          <Button
            className="link"
            onClick={() => this.onClickEdit(supplierData)}
          >
            <Image
              className="edit-icon"
              src={ICONS['icon-edit.svg']}
              alt="edit"
            />
          </Button>
        )

      default:
        break
    }
  }

  renderDetail = (
    supplierData = {
      approve_status: 0,
      company_name: '',
      contact_address: '',
      contact_country: '',
      email: '',
      full_name: '',
      id: null,
      is_active: 0,
      main_directory: false,
      phone: '',
      regis_address: '',
      regis_country: '',
      status: 0,
      tax_id: '',
      update_date: '',
    }
  ) => {
    return (
      <Table.TR key={supplierData.id}>
        <Table.TD className="tax-id">{supplierData.tax_id}</Table.TD>

        <Table.TD className="company-name">
          {supplierData.company_name}
        </Table.TD>

        <Table.TD className="main-directory">
          {supplierData.main_directory ? 'Yes' : 'No'}
        </Table.TD>

        <Table.TD className="status">
          {this.renderStatus(supplierData.approve_status)}
        </Table.TD>

        {/* <Table.TD className="sustainability-pre-assessment">
        <p className="completed-status">Completed</p>
      </Table.TD> */}

        <Table.TD className="active">
          <p
            className={
              supplierData.status === 2 ? 'active-status' : 'inactive-status'
            }
          >
            {supplierData.status === 2 ? 'Active' : 'inActive'}
          </p>
        </Table.TD>

        <Table.TD className="created-date">
          {dateMonDayYearTime(supplierData.update_date)}
        </Table.TD>

        <Table.TD className="actions">
          <Section>
            {this.renderButton(supplierData)}

            {/* <Button
            className="link"
            onClick={() => this.toggleModal()}
          >
            <Image
              className="history-icon"
              src={ICONS['icon-history.svg']}
              alt="history"
            />
          </Button> */}
          </Section>
        </Table.TD>
      </Table.TR>
    )
  }

  renderListSupplier = (listSupplier = []) => {
    return listSupplier.map(supplier => this.renderDetail(supplier))
  }

  render() {
    const {
      options,
      isHistoryModalOpen,
      resSuplierMamagementList,
      data,
    } = this.state
    return (
      <React.Fragment>
        <SupplierManagementAdminStyled>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_buyer_management"
                  src={ICONS['icon-user-group-white.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section id="page_title_buyer_management" className="title">
                  {STRING.SUPPLIER_MANAGEMENT}
                </Section>

                <Section
                  id="page_breadcrumb_buyer_management"
                  className="breadcrumbs"
                >
                  <Button
                    className="breadcrumb"
                    onClick={() => {
                      this.props.history.push(ROUTE_PATH.HOME.LINK)
                    }}
                  >
                    <span>{STRING.HOME}</span>
                  </Button>

                  <Button className="breadcrumb current">
                    <span>{STRING.SUPPLIER_MANAGEMENT}</span>
                  </Button>
                </Section>
              </Section>
            </Section>

            <Section className="page-button">
              <Button
                className="page-button"
                onClick={() => this.onClickExport()}
              >
                <Image src={ICONS['icon-export-white.svg']} alt="export icon" />
                Export
              </Button>

              {/* <Button className="page-button" onClick={() => {}}>
                <Image src={ICONS['icon-upload.svg']} alt="add icon" />
                Upload New Supplier List
              </Button> */}

              <Button
                className="page-button"
                onClick={() => {
                  this.props.history.push(
                    ROUTE_PATH.SUPPLIER_DETAIL_FORM_ADMIN.LINK
                  )
                }}
              >
                {/* <Image src={ICONS['icon-add-circular.svg']} alt="add icon" /> */}
                Create Supplier
              </Button>
            </Section>
          </Section>

          {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="main-content">
            <Section className="content-body">
              <Section className="table-filter">
                <InputSearch
                  type="text"
                  id="filter_search_input"
                  placeholder="Tax ID, Company Name"
                  onChange={this.onInputSearchChange}
                  value={this.state.searchKeyWord}
                  onKeyDown={this.onEnter}
                  onClickSearchClear={() => this.cleardata()}
                  clear={true}
                />

                <SelectBox
                  id="all_suppliers_filter"
                  className="table-filter all-suppliers"
                  options={options[0].allSuppliers}
                  placeholder="All Suppliers"
                  isSearchable={false}
                  isClearable={false}
                  onChange={event => {
                    this.onSelectSupplierType(event.id)
                  }}
                  value={this.matchValueSelected(
                    options[0].allSuppliers,
                    this.state.selectedSupplierStatus
                  )}
                />

                <SelectBox
                  id="all_status_filter"
                  className="table-filter all-status"
                  options={options[1].allStatus}
                  placeholder="All Status"
                  isSearchable={false}
                  isClearable={false}
                  onChange={event => this.onSelectStatusSuppiler(event.id)}
                  value={this.matchValueSelected(
                    options[1].allStatus,
                    this.state.selectedApproveStatus
                  )}
                />

                {/* <SelectBox
                  id="all_pre_assessment_filter"
                  className="table-filter all-pre-assessment"
                  options={options}
                  placeholder="All Pre-Assessment"
                  isSearchable={false}
                  isClearable={true}
                /> */}

                <SelectBox
                  id="active_status_filter"
                  className="table-filter active-status"
                  options={options[3].activeStatus}
                  placeholder="Active"
                  isSearchable={false}
                  isClearable={false}
                  onChange={event => this.onSelectAccountActive(event.id)}
                  value={this.matchValueSelected(
                    options[3].activeStatus,
                    this.state.selectedAccountStatus
                  )}
                />
              </Section>

              <Section className="table-wrapper">
                <Table className="buyer split-row-color">
                  {/* Header Row */}
                  <Table.THEAD>
                    <Table.TR className="header">
                      <Table.TH
                        className="tax-id"
                        id="tax_id_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('tax_id')}
                        onClick={() => this.toggleSort('tax_id')}
                      >
                        TAX ID
                      </Table.TH>

                      <Table.TH
                        className="company-name"
                        id="company_name_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('company_name')}
                        onClick={() => this.toggleSort('company_name')}
                      >
                        SUPPLIER NAME
                      </Table.TH>

                      <Table.TH
                        className="main-directory"
                        id="main_directory_header"
                      >
                        Main Directory
                      </Table.TH>

                      <Table.TH className="status" id="status_header">
                        STATUS
                      </Table.TH>

                      {/* <Table.TH
                        className="sustainability-pre-assessment"
                        id="sustainability_pre_assessment_header"
                      >
                        SUSTAINABILITY <br /> PRE-ASSESSMENT
                      </Table.TH> */}

                      <Table.TH className="active" id="active_header">
                        ACTIVE
                      </Table.TH>

                      <Table.TH
                        className="created-date"
                        id="create_date_header"
                      >
                        CREATED DATE
                      </Table.TH>

                      <Table.TH className="actions" id="actions_header">
                        ACTIONS
                      </Table.TH>
                    </Table.TR>
                  </Table.THEAD>

                  {/* Content Row */}
                  <Table.TBODY>
                    {this.state.isLoading ? (
                      <Spinner />
                    ) : (
                      this.renderListSupplier(this.state.data)
                    )}
                    {isEmpty(data) && (
                      <Section className="no-result-found">
                        <Image
                          src={ICONS['icon-ssr.png']}
                          className="no-result"
                        />
                        <p>No result found</p>
                      </Section>
                    )}
                  </Table.TBODY>
                </Table>
              </Section>
            </Section>

            <Section className="content-footer">
              <Section className="showing-item">
                Showing{' '}
                {data.length === 0
                  ? '0'
                  : Math.min(
                      (resSuplierMamagementList.page - 1) *
                        resSuplierMamagementList.limit +
                        1
                    )}{' '}
                to{' '}
                {Math.min(
                  resSuplierMamagementList.total_record,
                  resSuplierMamagementList.limit * resSuplierMamagementList.page
                )}{' '}
                of {resSuplierMamagementList.total_record} entries{' '}
              </Section>

              <Section className="paginate-wrapper">
                <Paginate
                  activePage={this.state.activePage}
                  itemsCountPerPage={this.state.resSuplierMamagementList.limit}
                  totalItemsCount={
                    this.state.resSuplierMamagementList.total_record || 0
                  }
                  // pageRangeDisplayed={
                  //   this.state.resSuplierMamagementList.total_page
                  // }
                  onChange={pageNumber => this.onPageChange(pageNumber)}
                />

                <Section className="moveto-wrapper">
                  <Input
                    className="paginate-moveto"
                    label="Page"
                    defaultValue="1"
                    isHorizontal
                    maxLength="4"
                    value={this.state.searchPag}
                    onChange={e =>
                      this.setState({ searchPage: parseInt(e.target.value) })
                    }
                  />

                  <Button
                    onClick={() => this.onPageChange(this.state.searchPage)}
                  >
                    go
                  </Button>
                </Section>
              </Section>
            </Section>
          </Section>
        </SupplierManagementAdminStyled>

        <Modal
          id="history_id"
          className="buyer history theme-blue"
          isOpen={isHistoryModalOpen}
        >
          <Modal.Header>History</Modal.Header>

          <Modal.Body>
            <Section className="table-header-freeze-wrapper">
              <Table className="history header-freeze">
                <Table.TBODY>
                  <Table.TR>
                    <Table.TH className="activity">ACTIVITY</Table.TH>

                    <Table.TH className="action-by">ACTION BY</Table.TH>

                    <Table.TH className="create-date">CREATED DATE</Table.TH>
                  </Table.TR>
                </Table.TBODY>
              </Table>

              <Table className="history split-row-color">
                <Table.TBODY>
                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>

                  <Table.TR>
                    <Table.TD className="activity">Activity_1</Table.TD>

                    <Table.TD className="action-by">TSpace Admin</Table.TD>

                    <Table.TD className="create-date">
                      Oct 08, 2019 14:00
                    </Table.TD>
                  </Table.TR>
                </Table.TBODY>
              </Table>
            </Section>
          </Modal.Body>

          <Modal.Footer>
            <Button
              id="close_modal_history_id"
              className="theme-border-gray close"
              onClick={() => this.toggleModal()}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    )
  }
}
